/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import SwiperCore, { Autoplay, Keyboard, Navigation } from 'swiper/core';

const Swiper = SwiperCore.use([Autoplay, Keyboard, Navigation]);

export function init() {
  const testimonialsSlider = new Swiper('[data-testimonials-slider]', {
    loop: true,
    autoplay: {
      delay: 5000,
    },
    navigation: {
      nextEl: '[data-testimonials-slider-next]',
      prevEl: '[data-testimonials-slider-prev]',
    },
    pagination: false,
  });

  const logosSlider = new Swiper('[data-logos-slider]', {
    slidesPerView: 2.1,
    centeredSlides: true,
    loop: true,
    autoplay: {
      delay: 5000,
    },
    navigation: false,
    pagination: false,
    breakpoints: {
      576: {
        slidesPerView: 2,
        centeredSlides: true,
      },
      700: {
        slidesPerView: 4,
        centeredSlides: true,
      },
    },
  });

  const productIngredientsSlider = new Swiper('[data-product-ingredients-slider]', {
    slidesPerView: 2.1,
    spaceBetween: 26,
    navigation: false,
    pagination: false,
    breakpoints: {
      576: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 4,
      },
      992: {
        slidesPerView: 6,
      },
    },
  });

  const productRelatedSlider = new Swiper('[data-product-related-slider]', {
    slidesPerView: 1.25,
    spaceBetween: 17,
    centeredSlides: true,
    loop: true,
    navigation: false,
    pagination: false,
    breakpoints: {
      576: {
        slidesPerView: 2,
        spaceBetween: 36,
        centeredSlides: true,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 36,
        centeredSlides: false,
      },
      1040: {
        slidesPerView: 4,
        spaceBetween: 37,
        centeredSlides: false,
      },
    },
  });

  const shopUspsSlider = new Swiper('[data-shop-usps-slider]', {
    loop: true,
    slidesPerView: 1,
    autoplay: {
      delay: 5000,
    },
    navigation: false,
    pagination: false,
    allowTouchMove: false,
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 10,
        centeredSlides: false,
      },
      1040: {
        slidesPerView: 3,
        spaceBetween: 10,
        centeredSlides: false,
      },
    },
  });
}



// WEBPACK FOOTER //
// ./scripts/modules/sliders.js